import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Modal, ModalCTA } from 'containers/misc'
import { Form, Title } from 'components/layout'
import { FormButton, Button, ButtonGroup } from 'components/misc'
import { AwardFileInfo } from 'components/sections/awards'
import { form } from 'helpers/decorators'
import { apiCodeLists } from 'helpers/decorators/api'
import { uploadFileValidation } from 'models/awards'

@apiCodeLists(['activitySections'])
@form({
  form: 'award-file-upload',
  validate: uploadFileValidation
})
class AwardFileEdit extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    submitting: PropTypes.bool,
    invalid: PropTypes.bool,
    isJourney: PropTypes.bool,
    data: PropTypes.object,
    codeLists: PropTypes.object.isRequired,
    editAwardFile: PropTypes.func.isRequired,
    cancelUpload: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    deleteFile: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired
  }
  static defaultProps = {}

  state = {
    file: null,
    idToDelete: null
  }

  componentWillMount = () =>
    this.props.data && this.handleInitForm(this.props.data)

  componentWillReceiveProps = nextProps => {
    const { data } = this.props

    if (get(data, 'id') !== get(nextProps, 'data.id')) {
      this.handleInitForm(nextProps.data)
    }
  }

  handleInitForm = data => {
    this.props.initialize(data)
  }

  handleIsRemoving = idToDelete => {
    this.setState({
      idToDelete
    })
  }

  handleEndRemoving = () => {
    this.setState({
      idToDelete: null
    })
  }

  handleRemove = id => {
    this.props.deleteFile(id)
    this.handleEndRemoving()
  }

  render() {
    const {
      modalId,
      handleSubmit,
      loading,
      codeLists,
      isJourney,
      submitting,
      invalid,
      data,
      initialize
    } = this.props
    const { idToDelete } = this.state

    return (
      <Modal id={modalId} customActions>
        <Form
          onSubmit={handleSubmit(this.props.editAwardFile)}
          loading={loading}
        >
          <AwardFileInfo
            codeLists={codeLists}
            isJourney={isJourney}
            data={data}
            initialize={initialize}
          />

          <div className="row">
            <div className="col-xs-6">
              {this.props.cancelUpload && (
                <ButtonGroup>
                  <Button
                    type="button"
                    secondary
                    intlKey="button.close"
                    onClick={this.props.cancelUpload}
                  >
                    Close
                  </Button>
                  <Button
                    type="button"
                    negative
                    intlKey="button.remove"
                    onClick={this.handleIsRemoving}
                  >
                    Remove
                  </Button>
                </ButtonGroup>
              )}
            </div>
            <div className="col-xs-6 text--right">
              <FormButton
                {...this.props}
                intlKey="button.edit"
                isLoading={submitting}
                disabled={invalid || loading}
              >
                edit
              </FormButton>
            </div>
          </div>
        </Form>
        {idToDelete && (
          <ModalCTA>
            <Title
              h2
              intlKey="moduleTitle.remove_file"
              className="text--center"
            >
              Remove file?
            </Title>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  intlKey="button.close"
                  secondary
                  onClick={this.handleEndRemoving}
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button
                  type="button"
                  negative
                  onClick={() => this.handleRemove(get(data, 'id'))}
                  intlKey="button.confirm"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </ModalCTA>
        )}
      </Modal>
    )
  }
}

export default AwardFileEdit
